import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountSearchComponent } from './account-search/account-search.component';
import { AgentDashboard } from './agent-dashboard/agent-dashboard-component';
import { AddServiceAccountComponent } from './agent-dashboard/add-service/add-service-account-component';
import { BillingSyncComponent } from './agent-dashboard/billing-sync/billing-sync-component';
import { ForgotAdminPasswordComponent } from './reset-password/forgot-password-component';
import { ResetAdminPasswordComponent } from './reset-password/reset-password-component';
import { FlagSearchComponent } from './agent-dashboard/flag-search/flag-search.component';
import { DppOverrideComponent } from './agent-dashboard/dpp-override/dpp-override.component';
import { ChargeBackComponent } from './agent-dashboard/chargeback-process/chargeback-process.component';
import {SupDownloadComponent} from './sup-download/sup-download.component';

const routes: Routes = [
  { path: 'internal-user/account-search', component: AccountSearchComponent},
  { path: 'internal-user/sup-download', component: SupDownloadComponent},
  { path: 'internal-user/service/add', component: AddServiceAccountComponent},
  { path: 'internal-user/dashboard', component: AgentDashboard},
  { path: 'internal-user/sync', component: BillingSyncComponent},
  { path: 'internal-user/forget-password', component: ForgotAdminPasswordComponent},
  { path: 'internal-user/reset-password/:token', component: ResetAdminPasswordComponent},
  { path: 'internal-user/flag-search', component: FlagSearchComponent},
  { path: 'internal-user/dpp-override', component: DppOverrideComponent},
  { path: 'internal-user/chargeback-process', component: ChargeBackComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AgentRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/agent/agent-routing.module.ts